<dspx-card-set-base-form [formServiceEndpoint]="formServiceEndpoint"
                         [templateId]="templateId"
                         [versionNo]="versionNo"
                         [model]="model"
                         formName="Agency List"
                         (onFormLoad)="formLoad($event)"
                         (onDialogSubmit)="dialogSubmitted($event)"
                         (onActionButtonClick)="handleActionButtonClick($event)"
                         (onFilter)="filterData($event)">
</dspx-card-set-base-form>
